<template>
  <figure class="testimonial-wrapper">
    <figcaption><slot></slot></figcaption>
    <img :src="img1x" :srcset="img2x" :alt="alt" :style="`object-position:${position}`">
  </figure>
</template>

<script>
  export default {
    name: 'testimonial',

    props: {
      src: {
        required: true,
        type: String
      },
      src2:  {
        required: true,
        type: String
      },
      alt: {
        required: true,
        type: String
      },
      position: {
        required: false,
        type: String
      }
    },

    computed: {
      img1x() {
        return "https://s3.amazonaws.com/s3.pilates.com/contrology/" + this.src;
      },

      img2x() {
        return "https://s3.amazonaws.com/s3.pilates.com/contrology/" + this.src2 + ' 2x';
      }
    }
  }
</script>

<style lang="scss" scoped>
.testimonial-wrapper {
  margin: 30px 0;
  width: 100%;
  display: flex;
  flex-flow: column nowrap;
  align-items: center;
}

figcaption {
  font-family: var(--noto);
  font-style: italic;
  font-weight: 300;
  font-size: 1.25rem;
  line-height: 1.35;
  color: var(--white);
  background-color: rgba(0, 0, 0, 0.8);
  padding: 7%;
  margin: 0 5% -70px;
  position: relative;
  max-width: 480px;
}

figcaption a {
  color: var(--white);
  text-decoration-style: solid;
  text-underline-position: under;
}

img {
  display: block;
  object-fit: cover;
  width: 100%;
  height: 588px;
}

@media only screen and (min-width:768px) {
  .testimonial-wrapper {
    margin: 55px auto 0;
    max-width: 592px;
  }

  figcaption span {
    white-space: nowrap;
  }
}

@media only screen and (min-width:1024px) {
  .testimonial-wrapper {
    display: grid;
    grid-template-columns: 45px auto;
    grid-template-rows: 395px 1fr;
    max-width: 1190px;
    margin: 50px auto 0;
  }

  figcaption {
    grid-column: 1 / span 2;
    grid-row: 1 / span 1;
    padding: 4%;
    margin: 0;
    font-size: 1.125rem;
    line-height: 1.5;
    max-width: 370px;
  }

  img {
    grid-column: 2 / span 1;
    grid-row: 1 / span 2;
    margin: 0;
    width: 100%;
    max-width: 1148px;
  }
}

@media only screen and (min-width:1208px) {
  figcaption {
    max-width: 460px;
  }
}
</style>